import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import ArUnderlinedLink from 'src/components/typography/ArUnderlinedLink'
import PropTypes from 'prop-types'
import React from 'react'
import { generateJSX } from 'src/utils'
import { media } from 'src/styles/styled-components'
import styled from 'styled-components'

const StyledContainer = styled(ArBaseContainer)`
  margin-bottom: ${ ({ customMargin }) => customMargin ? 40 : 40 }px;
  margin-top: ${ ({ customMargin }) => customMargin ? 30 : 30 }px;
  max-width: ${ p => 745 + 2 * p.theme.gridGutter + 'px' };

  ${ media.tablet`
    margin-top: ${ ({ customMargin }) => customMargin ? 90 : 90 }px;
    margin-bottom: ${ ({ customMargin }) => customMargin ? 50 : 130 }px;
  ` }

  ${ media.desktop`
    margin-top: ${ ({ customMargin }) => customMargin ? 100 : 100 }px;
    margin-bottom: ${ ({ customMargin }) => customMargin ? 50 : 120 }px;
  ` }
`

const StyledTitle = styled.h2`
  font-size: 2.8rem;
  font-weight: ${ p => p.theme.fontWeight.primary.Light };
  line-height: 1.18;
  margin-bottom: 20px;
  text-align: center;

  ${ media.tablet`
    font-size: 3.8rem;
    margin-bottom: 30px;
  ` }

  ${ media.desktop`
    font-size: 4.5rem;
  ` }
`

const StyledDescription = styled.p`
  font-size: 1.8rem;
  font-weight: ${ p => p.theme.fontWeight.primary.Light };
  letter-spacing: 0.01em;
  line-height: 1.55;
  text-align: center;

  > a {
    color: ${ p => p.theme.colors.red };
    ${ ArUnderlinedLink }
  }
`

class ArPostSimple extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.oneOfType([ PropTypes.array, PropTypes.string ]),
  }

  render () {
    const { title, description, customMargin } = this.props
    return (
      <StyledContainer customMargin={customMargin}>
        <StyledTitle>{ title }</StyledTitle>
        <StyledDescription>{ generateJSX(description) }</StyledDescription>
      </StyledContainer>
    )
  }
}

export default ArPostSimple
